import { render, staticRenderFns } from "./WBotsItemMask.vue?vue&type=template&id=43ecb612&"
import script from "./WBotsItemMask.vue?vue&type=script&lang=js&"
export * from "./WBotsItemMask.vue?vue&type=script&lang=js&"
import style0 from "./WBotsItemMask.vue?vue&type=style&index=0&id=43ecb612&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports